import { apiClient, downloadApiFile } from "../services/api";
import type { ExportFilterOptions, ExportRequestOptions, ExportSchema } from "./types";

export async function getExportSchema(reportType: string, via?: string): Promise<ExportSchema> {
  const response = await apiClient.get<ExportSchema>(
    `/api/export/${encodeURIComponent(reportType)}/schema`,
    { params: via ? { via } : undefined },
  );
  return response.data;
}

export async function getExportFilterOptions(
  reportType: string,
  params: Record<string, string | undefined>,
): Promise<ExportFilterOptions> {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") query.append(key, value);
  });
  const response = await apiClient.get<ExportFilterOptions>(
    `/api/export/${encodeURIComponent(reportType)}/filter-options?${query.toString()}`,
  );
  return response.data;
}

export function buildExportQuery(
  options: ExportRequestOptions,
  params: Record<string, string | undefined>,
): URLSearchParams {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") query.append(key, value);
  });
  query.set("format", options.format);
  if (options.columns.length > 0) query.set("columns", options.columns.join(","));
  query.set("rowScope", options.rowScope);
  if (options.rowScope === "top" && options.topN != null) {
    query.set("topN", String(options.topN));
  }
  if (options.rowScope === "filtered" && options.search?.trim()) {
    query.set("search", options.search.trim());
  }
  if (options.sort) {
    query.set("sortField", options.sort.field);
    query.set("sortDirection", options.sort.direction);
  }
  Object.entries(options.filters ?? {}).forEach(([key, values]) => {
    if (values.length > 0) query.set(key, values.join(","));
  });
  if (options.granularity) query.set("granularity", options.granularity);
  if (options.omitTables?.length) query.set("omitTables", options.omitTables.join(","));
  return query;
}

export async function runExport(
  reportType: string,
  options: ExportRequestOptions,
  params: Record<string, string | undefined>,
): Promise<void> {
  const query = buildExportQuery(options, params);
  await downloadApiFile(
    `/api/export/${encodeURIComponent(reportType)}?${query.toString()}`,
    `${reportType.replace(/\./g, "-")}.${options.format}`,
  );
}
